export default function hasReadOrderPermissions(permissions, environment) {
  return permissions && permissions.orderManagement
    ? !!permissions.orderManagement.find(
        p =>
          (p.identifier === environment || p.identifier === '*') &&
          p.permissions.includes('read:order')
      )
    : false;
}
